import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export interface OcrData {
  lines: OcrLine[];
}

export interface OcrLine {
  words: OcrWord[];
}

export interface OcrWord {
  text: string;
  position: OcrRect;
}

export interface OcrRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface OcrDataProvider {
  provideOcrData(pageId: string): Observable<OcrData>;
}

export const OCR_DATA_PROVIDER_TOKEN = new InjectionToken<OcrDataProvider>('OcrDataProvider');
